// ============ Hospital ============
export interface Hospital {
  id: number;
  name: string;
  city: string;
  specialties: string[];
  rating: number;
  reviews: number;
  isTop: boolean;
  image: string;
  description: string;
  accreditation: string[];
  departments: string[];
}

export const cities = ["All", "Beijing", "Shanghai", "Guangzhou", "Chengdu", "Shenzhen"];
export const allSpecialties = [
  "All", "Oncology", "Cardiology", "Neurology", "Orthopedics",
  "Surgery", "Rehabilitation", "Comprehensive", "Multi-specialty",
];

export const mockHospitals: Hospital[] = [
  {
    id: 1, name: "Peking Union Medical College Hospital", city: "Beijing",
    specialties: ["Comprehensive", "Multi-specialty", "Cardiology", "Neurology"],
    rating: 4.8, reviews: 1260, isTop: true, image: "/images/hospital-peking.jpg",
    description: "One of China's most prestigious hospitals, founded in 1921. Known for comprehensive care and cutting-edge research.",
    accreditation: ["JCI Accredited", "Grade 3A Hospital", "ISO 9001"],
    departments: ["Internal Medicine", "Surgery", "Cardiology", "Neurology", "Oncology", "Orthopedics"],
  },
  {
    id: 2, name: "Shanghai Ruijin Hospital", city: "Shanghai",
    specialties: ["Oncology", "Cardiology", "Surgery"],
    rating: 4.7, reviews: 980, isTop: true, image: "/images/hospital-ruijin.jpg",
    description: "A leading tertiary hospital in Shanghai with strong oncology and cardiovascular departments.",
    accreditation: ["JCI Accredited", "Grade 3A Hospital"],
    departments: ["Oncology", "Cardiology", "Hematology", "Endocrinology", "Surgery"],
  },
  {
    id: 3, name: "West China Hospital", city: "Chengdu",
    specialties: ["Neurology", "Surgery", "Orthopedics"],
    rating: 4.7, reviews: 856, isTop: false, image: "/images/hospital-chengdu.jpg",
    description: "Affiliated with Sichuan University, one of the largest hospitals in Western China.",
    accreditation: ["Grade 3A Hospital", "ISO 14001"],
    departments: ["Neurology", "Neurosurgery", "Orthopedics", "Rehabilitation", "Surgery"],
  },
  {
    id: 4, name: "Guangzhou First People's Hospital", city: "Guangzhou",
    specialties: ["Orthopedics", "Rehabilitation", "Surgery"],
    rating: 4.6, reviews: 720, isTop: false, image: "/images/hospital-guangzhou.jpg",
    description: "A comprehensive municipal hospital with excellent orthopedic and rehabilitation services.",
    accreditation: ["Grade 3A Hospital"],
    departments: ["Orthopedics", "Rehabilitation", "Sports Medicine", "Surgery", "Internal Medicine"],
  },
  {
    id: 5, name: "Shenzhen People's Hospital", city: "Shenzhen",
    specialties: ["Comprehensive", "Cardiology", "Oncology"],
    rating: 4.5, reviews: 640, isTop: false, image: "/images/hospital-shenzhen.jpg",
    description: "The largest comprehensive hospital in Shenzhen with modern facilities.",
    accreditation: ["Grade 3A Hospital"],
    departments: ["Cardiology", "Oncology", "Internal Medicine", "Surgery", "Pediatrics"],
  },
  {
    id: 6, name: "Beijing Tiantan Hospital", city: "Beijing",
    specialties: ["Neurology", "Neurosurgery", "Comprehensive"],
    rating: 4.8, reviews: 1100, isTop: true, image: "/images/hospital-tiantan.jpg",
    description: "China's leading neurosurgery center, affiliated with Capital Medical University.",
    accreditation: ["JCI Accredited", "Grade 3A Hospital"],
    departments: ["Neurosurgery", "Neurology", "Stroke Center", "Rehabilitation", "Surgery"],
  },
  {
    id: 7, name: "Zhejiang University First Affiliated Hospital", city: "Hangzhou",
    specialties: ["Comprehensive", "Cardiology", "Oncology"],
    rating: 4.7, reviews: 890, isTop: false, image: "/images/hospital-peking.jpg",
    description: "One of China's top university hospitals with world-class research and clinical care facilities.",
    accreditation: ["Grade 3A Hospital", "ISO 9001"],
    departments: ["Internal Medicine", "Cardiology", "Oncology", "Surgery", "Emergency Medicine"],
  },
  {
    id: 8, name: "Chongqing Medical University First Affiliated Hospital", city: "Chongqing",
    specialties: ["Multi-specialty", "Neurology", "Orthopedics"],
    rating: 4.6, reviews: 760, isTop: false, image: "/images/hospital-peking.jpg",
    description: "A leading tertiary medical center in southwest China serving millions of patients annually.",
    accreditation: ["Grade 3A Hospital", "ISO 14001"],
    departments: ["Neurology", "Orthopedics", "Surgery", "Pediatrics", "Internal Medicine"],
  },
  {
    id: 9, name: "Nanjing Drum Tower Hospital", city: "Nanjing",
    specialties: ["Comprehensive", "Oncology", "Surgery"],
    rating: 4.5, reviews: 680, isTop: false, image: "/images/hospital-peking.jpg",
    description: "A historic hospital with over 120 years of excellence in patient care and medical education.",
    accreditation: ["Grade 3A Hospital"],
    departments: ["Oncology", "General Surgery", "Cardiology", "Neurology", "Rehabilitation"],
  },
  {
    id: 10, name: "Wuhan Union Hospital", city: "Wuhan",
    specialties: ["Multi-specialty", "Cardiology", "Rehabilitation"],
    rating: 4.4, reviews: 540, isTop: false, image: "/images/hospital-peking.jpg",
    description: "A renowned medical institution in central China affiliated with Tongji Medical College.",
    accreditation: ["Grade 3A Hospital", "ISO 9001"],
    departments: ["Cardiology", "Internal Medicine", "Surgery", "Rehabilitation", "Obstetrics"],
  },
  {
    id: 11, name: "First Affiliated Hospital of Xi'an Jiaotong University", city: "Xian",
    specialties: ["Comprehensive", "Orthopedics", "Oncology"],
    rating: 4.3, reviews: 450, isTop: false, image: "/images/hospital-peking.jpg",
    description: "A leading medical center in northwest China with strong academic and clinical programs.",
    accreditation: ["Grade 3A Hospital"],
    departments: ["Orthopedics", "Oncology", "Surgery", "Neurology", "Internal Medicine"],
  },
  {
    id: 12, name: "Suzhou Municipal Hospital", city: "Suzhou",
    specialties: ["Comprehensive", "Cardiology", "Surgery"],
    rating: 4.2, reviews: 380, isTop: false, image: "/images/hospital-peking.jpg",
    description: "A modern general hospital providing high-quality medical services in the Suzhou region.",
    accreditation: ["Grade 3A Hospital", "ISO 9001"],
    departments: ["Cardiology", "General Surgery", "Pediatrics", "Emergency Medicine", "Internal Medicine"],
  },
];

// ============ Medical Services ============
export interface MedicalService {
  id: string;
  title: string;
  category: string;
  description: string;
  details: string[];
  priceRange: string;
  duration: string;
  icon: string;
  color: string;
  bgColor: string;
}

export const medicalServices: MedicalService[] = [
  {
    id: "comprehensive-checkup", title: "Comprehensive Health Checkup",
    category: "Health Checkup", icon: "stethoscope", color: "#0F6B68", bgColor: "#E6F5F3",
    description: "Full-body health screening with advanced imaging and lab tests.",
    details: ["Blood tests & biomarkers", "CT / MRI imaging", "Cardiovascular screening", "Cancer marker tests", "Detailed report in English"],
    priceRange: "$500 – $2,000", duration: "1–2 days",
  },
  {
    id: "dental-checkup", title: "Dental Examination & Cleaning",
    category: "Health Checkup", icon: "stethoscope", color: "#0F6B68", bgColor: "#E6F5F3",
    description: "Professional dental assessment, cleaning, and treatment planning.",
    details: ["Oral examination", "Dental X-rays", "Professional cleaning", "Treatment plan"],
    priceRange: "$100 – $500", duration: "1 day",
  },
  {
    id: "cardiology-treatment", title: "Cardiology Consultation & Treatment",
    category: "Medical Treatment", icon: "hospital", color: "#2FA79B", bgColor: "#E6F5F3",
    description: "Expert cardiovascular diagnosis and treatment from leading cardiologists.",
    details: ["ECG & echocardiogram", "Cardiac catheterization", "Medication management", "Follow-up care plan"],
    priceRange: "$1,000 – $8,000", duration: "3–7 days",
  },
  {
    id: "oncology-treatment", title: "Oncology Consultation & Treatment",
    category: "Medical Treatment", icon: "hospital", color: "#2FA79B", bgColor: "#E6F5F3",
    description: "Comprehensive cancer diagnosis and treatment planning.",
    details: ["Tumor biopsy & pathology", "PET-CT scanning", "Chemotherapy / immunotherapy", "Multidisciplinary review"],
    priceRange: "$3,000 – $15,000", duration: "5–14 days",
  },
  {
    id: "orthopedic-surgery", title: "Orthopedic Surgery",
    category: "Surgery Services", icon: "scalpel", color: "#E07A5F", bgColor: "#FDF0ED",
    description: "Joint replacement, spine surgery, and sports injury procedures.",
    details: ["Pre-surgery assessment", "Joint replacement surgery", "Minimally invasive options", "Post-op rehabilitation plan"],
    priceRange: "$5,000 – $20,000", duration: "7–21 days",
  },
  {
    id: "cosmetic-surgery", title: "Cosmetic & Plastic Surgery",
    category: "Surgery Services", icon: "scalpel", color: "#E07A5F", bgColor: "#FDF0ED",
    description: "Aesthetic procedures performed by board-certified plastic surgeons.",
    details: ["Consultation & design", "Surgical procedure", "Recovery monitoring", "Follow-up visits"],
    priceRange: "$2,000 – $10,000", duration: "3–10 days",
  },
  {
    id: "post-surgery-rehab", title: "Post-Surgery Rehabilitation",
    category: "Recovery & Rehabilitation", icon: "heart-pulse", color: "#8B5CF6", bgColor: "#F3EEFF",
    description: "Structured rehabilitation programs after surgery or injury.",
    details: ["Physical therapy", "Occupational therapy", "Progress tracking", "Discharge planning"],
    priceRange: "$200 – $800/week", duration: "2–8 weeks",
  },
  {
    id: "stroke-recovery", title: "Stroke Recovery Program",
    category: "Recovery & Rehabilitation", icon: "heart-pulse", color: "#8B5CF6", bgColor: "#F3EEFF",
    description: "Specialized stroke rehabilitation with multidisciplinary team.",
    details: ["Neurological assessment", "Motor function therapy", "Speech therapy", "Family training"],
    priceRange: "$300 – $1,000/week", duration: "4–12 weeks",
  },
  {
    id: "advanced-oncology-care", title: "Advanced Oncology Treatment",
    category: "Oncology Treatment", icon: "hospital", color: "#DC2626", bgColor: "#FEE2E2",
    description: "Comprehensive cancer care including targeted therapy, immunotherapy, and precision medicine.",
    details: ["Molecular profiling", "Targeted therapy options", "Immunotherapy treatment", "Clinical trial enrollment", "Multidisciplinary tumor board"],
    priceRange: "$5,000 – $25,000", duration: "7–28 days",
  },
  {
    id: "dental-care-service", title: "Dental Care & Implants",
    category: "Dental Care", icon: "stethoscope", color: "#2563EB", bgColor: "#DBEAFE",
    description: "Full-service dental care including implants, orthodontics, and cosmetic dentistry.",
    details: ["Comprehensive oral exam", "Digital X-ray imaging", "Dental implant surgery", "Cosmetic whitening", "Post-procedure follow-up"],
    priceRange: "$150 – $3,500", duration: "1–3 days",
  },
  {
    id: "stroke-prevention-screening", title: "Stroke Prevention Screening",
    category: "Neurological Care", icon: "heart-pulse", color: "#0891B2", bgColor: "#CFFAFE",
    description: "Early detection and risk assessment for stroke with personalized prevention plan.",
    details: ["Carotid ultrasound", "Blood pressure monitoring", "Blood clotting tests", "Brain MRI screening", "Preventive medication plan"],
    priceRange: "$400 – $1,200", duration: "1 day",
  },
  {
    id: "neurological-consultation", title: "Neurological Consultation",
    category: "Neurological Care", icon: "hospital", color: "#0891B2", bgColor: "#CFFAFE",
    description: "Expert diagnosis and treatment planning for neurological conditions.",
    details: ["Detailed neurological exam", "EEG / EMG testing", "Brain imaging review", "Treatment plan development", "Referral to specialists"],
    priceRange: "$200 – $1,500", duration: "1–2 days",
  },
  {
    id: "mental-health-consultation", title: "Mental Health Consultation",
    category: "Mental Health", icon: "heart-pulse", color: "#7C3AED", bgColor: "#EDE9FE",
    description: "Professional psychiatric evaluation and counseling services.",
    details: ["Psychiatric assessment", "Cognitive behavioral therapy", "Medication management", "Support group referral", "Online follow-up sessions"],
    priceRange: "$150 – $600", duration: "1–7 days",
  },
  {
    id: "pain-management-clinic", title: "Pain Management Clinic",
    category: "Medical Treatment", icon: "stethoscope", color: "#2FA79B", bgColor: "#E6F5F3",
    description: "Interventional and non-pharmacological pain management solutions.",
    details: ["Comprehensive pain assessment", "Nerve block procedures", "Physical therapy integration", "Medication optimization", "Chronic pain program"],
    priceRange: "$300 – $2,000", duration: "2–14 days",
  },
  {
    id: "traditional-chinese-medicine", title: "Traditional Chinese Medicine Therapy",
    category: "Medical Treatment", icon: "heart-pulse", color: "#2FA79B", bgColor: "#E6F5F3",
    description: "Holistic TCM treatments including acupuncture, herbal medicine, and tuina massage.",
    details: ["TCM pattern diagnosis", "Custom herbal prescriptions", "Acupuncture therapy", "Tuina massage sessions", "Dietary and lifestyle advice"],
    priceRange: "$100 – $800/week", duration: "1–4 weeks",
  },
  {
    id: "weight-management-program", title: "Weight Management Program",
    category: "Health Checkup", icon: "stethoscope", color: "#0F6B68", bgColor: "#E6F5F3",
    description: "Customized medical weight loss program with nutrition counseling and exercise plan.",
    details: ["Body composition analysis", "Metabolic health screening", "Custom nutrition plan", "Personal training sessions", "Progress monitoring app"],
    priceRange: "$500 – $2,500", duration: "2–12 weeks",
  },
  {
    id: "fertility-assessment", title: "Fertility Assessment & Counseling",
    category: "Health Checkup", icon: "stethoscope", color: "#0F6B68", bgColor: "#E6F5F3",
    description: "Comprehensive fertility evaluation for both men and women with personalized guidance.",
    details: ["Hormone level analysis", "Ultrasound imaging", "Semen analysis for men", "Ovarian reserve testing", "Treatment options counseling"],
    priceRange: "$600 – $2,000", duration: "1–5 days",
  },
  {
    id: "ophthalmology-consultation", title: "Ophthalmology Consultation",
    category: "Medical Treatment", icon: "hospital", color: "#2FA79B", bgColor: "#E6F5F3",
    description: "Complete eye examination and treatment for vision and eye health conditions.",
    details: ["Comprehensive eye exam", "Optical coherence tomography", "Glaucoma screening", "Cataract evaluation", "Laser vision correction consult"],
    priceRange: "$150 – $3,000", duration: "1 day",
  },
  {
    id: "vip-health-checkup", title: "VIP Health Checkup Service",
    category: "Health Checkup", icon: "stethoscope", color: "#0F6B68", bgColor: "#E6F5F3",
    description: "Premium concierge health screening with exclusive access and same-day results.",
    details: ["Private VIP room access", "Same-day comprehensive results", "One-on-one physician debrief", "Lifestyle optimization report", "Annual follow-up planning"],
    priceRange: "$1,500 – $5,000", duration: "1 day",
  },
  {
    id: "teleconsultation-remote", title: "Teleconsultation (Remote)",
    category: "Medical Treatment", icon: "hospital", color: "#2FA79B", bgColor: "#E6F5F3",
    description: "Secure video consultation with leading Chinese specialists from anywhere in the world.",
    details: ["HD video conferencing", "Electronic health record sharing", "Second opinion reports", "Treatment plan recommendations", "Prescription coordination"],
    priceRange: "$100 – $500", duration: "30–60 min",
  },
];

// ============ Doctors ============
export interface Doctor {
  id: number;
  name: string;
  title: string;
  hospital: string;
  hospitalId: number;
  specialties: string[];
  experience: number;
  languages: string[];
  bio: string;
  rating: number;
  reviews: number;
  image: string;
}

export const mockDoctors: Doctor[] = [
  {
    id: 1, name: "Dr. Wang Wei", title: "Chief Physician, Cardiology",
    hospital: "Peking Union Medical College Hospital", hospitalId: 1,
    specialties: ["Cardiology", "Interventional Cardiology"],
    experience: 22, languages: ["Chinese", "English"],
    bio: "Leading cardiologist with expertise in interventional procedures and heart failure management.",
    rating: 4.9, reviews: 340, image: "/images/doctor-wang-wei.jpg",
  },
  {
    id: 2, name: "Dr. Li Ming", title: "Professor of Oncology",
    hospital: "Shanghai Ruijin Hospital", hospitalId: 2,
    specialties: ["Oncology", "Hematology"],
    experience: 18, languages: ["Chinese", "English"],
    bio: "Renowned oncologist specializing in targeted therapy and immunotherapy for solid tumors.",
    rating: 4.8, reviews: 280, image: "/images/doctor-li-ming.jpg",
  },
  {
    id: 3, name: "Dr. Zhang Hua", title: "Director of Neurosurgery",
    hospital: "Beijing Tiantan Hospital", hospitalId: 6,
    specialties: ["Neurosurgery", "Neurology"],
    experience: 25, languages: ["Chinese", "English", "Japanese"],
    bio: "Pioneer in minimally invasive neurosurgery with over 5,000 successful procedures.",
    rating: 4.9, reviews: 420, image: "/images/doctor-zhang-hua.jpg",
  },
  {
    id: 4, name: "Dr. Chen Xiao", title: "Associate Professor, Orthopedics",
    hospital: "West China Hospital", hospitalId: 3,
    specialties: ["Orthopedics", "Sports Medicine"],
    experience: 15, languages: ["Chinese", "English"],
    bio: "Specialist in joint replacement and sports injury rehabilitation.",
    rating: 4.7, reviews: 195, image: "/images/doctor-chen-xiao.jpg",
  },
  {
    id: 5, name: "Dr. Liu Yan", title: "Chief Physician, Rehabilitation",
    hospital: "Guangzhou First People's Hospital", hospitalId: 4,
    specialties: ["Rehabilitation", "Physical Therapy"],
    experience: 20, languages: ["Chinese", "English", "Cantonese"],
    bio: "Expert in post-surgical rehabilitation and chronic pain management.",
    rating: 4.8, reviews: 260, image: "/images/doctor-liu-yan.jpg",
  },
  {
    id: 6, name: "Dr. Sun Lei", title: "Professor of Internal Medicine",
    hospital: "Shenzhen People's Hospital", hospitalId: 5,
    specialties: ["Internal Medicine", "Endocrinology"],
    experience: 16, languages: ["Chinese", "English"],
    bio: "Specialist in diabetes management and metabolic disorders.",
    rating: 4.6, reviews: 175, image: "/images/doctor-sun-lei.jpg",
  },
  {
    id: 7, name: "Dr. Zhou Qing", title: "Chief Physician, Cardiology",
    hospital: "Zhejiang University First Affiliated Hospital", hospitalId: 7,
    specialties: ["Cardiology", "Interventional Cardiology"],
    experience: 19, languages: ["Chinese", "English"],
    bio: "Expert in coronary artery disease treatment and pacemaker implantation.",
    rating: 4.7, reviews: 230, image: "/images/doctor-wang-wei.jpg",
  },
  {
    id: 8, name: "Dr. He Jun", title: "Associate Professor, Neurology",
    hospital: "Chongqing Medical University First Affiliated Hospital", hospitalId: 8,
    specialties: ["Neurology", "Stroke Medicine"],
    experience: 14, languages: ["Chinese", "English"],
    bio: "Specialist in stroke prevention and neurorehabilitation therapies.",
    rating: 4.5, reviews: 180, image: "/images/doctor-li-ming.jpg",
  },
  {
    id: 9, name: "Dr. Xu Mei", title: "Professor of Oncology",
    hospital: "Nanjing Drum Tower Hospital", hospitalId: 9,
    specialties: ["Oncology", "Thoracic Oncology"],
    experience: 21, languages: ["Chinese", "English"],
    bio: "Leading researcher in lung cancer treatment and precision medicine approaches.",
    rating: 4.6, reviews: 210, image: "/images/doctor-zhang-hua.jpg",
  },
  {
    id: 10, name: "Dr. Huang Tao", title: "Chief Physician, Rehabilitation",
    hospital: "Wuhan Union Hospital", hospitalId: 10,
    specialties: ["Rehabilitation", "Physical Medicine"],
    experience: 17, languages: ["Chinese", "English"],
    bio: "Specialist in comprehensive rehabilitation after neurological and orthopedic injuries.",
    rating: 4.4, reviews: 150, image: "/images/doctor-chen-xiao.jpg",
  },
  {
    id: 11, name: "Dr. Qian Bing", title: "Director of Orthopedics",
    hospital: "First Affiliated Hospital of Xi'an Jiaotong University", hospitalId: 11,
    specialties: ["Orthopedics", "Joint Replacement"],
    experience: 23, languages: ["Chinese", "English"],
    bio: "Pioneer in minimally invasive joint replacement surgery with excellent outcomes.",
    rating: 4.5, reviews: 190, image: "/images/doctor-liu-yan.jpg",
  },
  {
    id: 12, name: "Dr. Wu Fang", title: "Associate Professor, General Surgery",
    hospital: "Suzhou Municipal Hospital", hospitalId: 12,
    specialties: ["Surgery", "Minimally Invasive Surgery"],
    experience: 13, languages: ["Chinese", "English"],
    bio: "Expert in laparoscopic surgery and advanced minimally invasive techniques.",
    rating: 4.3, reviews: 140, image: "/images/doctor-sun-lei.jpg",
  },
];

// ============ Booking ============
export type BookingStatus = "pending" | "under_review" | "coordinating" | "confirmed" | "completed" | "cancelled";

export interface Booking {
  id: string;
  serviceTitle: string;
  hospitalName: string;
  doctorName: string;
  preferredDate: string;
  submittedAt: string;
  status: BookingStatus;
  statusNote: string;
  /** Optional demo-only fields captured from the request form. */
  guestName?: string;
  email?: string;
  country?: string;
  language?: string;
  contactPref?: string;
  requirements?: string;
  source?: "seed" | "patient-demo";
}

export const mockBookings: Booking[] = [
  {
    id: "BK-2026-001", serviceTitle: "Comprehensive Health Checkup",
    hospitalName: "Peking Union Medical College Hospital", doctorName: "Dr. Wang Wei",
    preferredDate: "2026-12-15", submittedAt: "2026-10-20",
    status: "under_review", statusNote: "Your request is being reviewed by our medical team.",
  },
  {
    id: "BK-2026-002", serviceTitle: "Cardiology Consultation",
    hospitalName: "Shanghai Ruijin Hospital", doctorName: "Dr. Li Ming",
    preferredDate: "2026-11-20", submittedAt: "2026-10-10",
    status: "coordinating", statusNote: "We are coordinating with the hospital for your appointment.",
  },
  {
    id: "BK-2026-003", serviceTitle: "Orthopedic Surgery Assessment",
    hospitalName: "West China Hospital", doctorName: "Dr. Chen Xiao",
    preferredDate: "2026-10-01", submittedAt: "2026-09-15",
    status: "completed", statusNote: "Your treatment has been completed. Follow-up scheduled.",
  },
  {
    id: "BK-2026-004", serviceTitle: "Advanced Oncology Treatment",
    hospitalName: "Shanghai Ruijin Hospital", doctorName: "Dr. Li Ming",
    preferredDate: "2026-11-05", submittedAt: "2026-10-22",
    status: "pending", statusNote: "Your request has been received and is awaiting initial screening.",
  },
  {
    id: "BK-2026-005", serviceTitle: "Neurological Consultation",
    hospitalName: "Beijing Tiantan Hospital", doctorName: "Dr. Zhang Hua",
    preferredDate: "2026-11-12", submittedAt: "2026-10-25",
    status: "pending", statusNote: "Your request has been received and is awaiting initial screening.",
  },
  {
    id: "BK-2026-006", serviceTitle: "Comprehensive Health Checkup",
    hospitalName: "Peking Union Medical College Hospital", doctorName: "Dr. Wang Wei",
    preferredDate: "2026-12-01", submittedAt: "2026-10-28",
    status: "pending", statusNote: "Your request has been received and is awaiting initial screening.",
  },
  {
    id: "BK-2026-007", serviceTitle: "Mental Health Consultation",
    hospitalName: "Shenzhen People's Hospital", doctorName: "Dr. Sun Lei",
    preferredDate: "2026-11-18", submittedAt: "2026-10-30",
    status: "pending", statusNote: "Your request has been received and is awaiting initial screening.",
  },
  {
    id: "BK-2026-008", serviceTitle: "Stroke Prevention Screening",
    hospitalName: "Chongqing Medical University First Affiliated Hospital", doctorName: "Dr. He Jun",
    preferredDate: "2026-12-10", submittedAt: "2026-11-02",
    status: "pending", statusNote: "Your request has been received and is awaiting initial screening.",
  },
  {
    id: "BK-2026-009", serviceTitle: "Weight Management Program",
    hospitalName: "Wuhan Union Hospital", doctorName: "Dr. Huang Tao",
    preferredDate: "2026-12-20", submittedAt: "2026-11-05",
    status: "pending", statusNote: "Your request has been received and is awaiting initial screening.",
  },
  {
    id: "BK-2026-010", serviceTitle: "VIP Health Checkup Service",
    hospitalName: "Zhejiang University First Affiliated Hospital", doctorName: "Dr. Zhou Qing",
    preferredDate: "2026-12-28", submittedAt: "2026-11-08",
    status: "pending", statusNote: "Your request has been received and is awaiting initial screening.",
  },
  {
    id: "BK-2026-011", serviceTitle: "Ophthalmology Consultation",
    hospitalName: "Suzhou Municipal Hospital", doctorName: "Dr. Wu Fang",
    preferredDate: "2026-11-25", submittedAt: "2026-10-29",
    status: "pending", statusNote: "Your request has been received and is awaiting initial screening.",
  },
  {
    id: "BK-2026-012", serviceTitle: "Dental Care & Implants",
    hospitalName: "Guangzhou First People's Hospital", doctorName: "Dr. Liu Yan",
    preferredDate: "2026-11-08", submittedAt: "2026-10-18",
    status: "under_review", statusNote: "Your request is being reviewed by our medical team.",
  },
  {
    id: "BK-2026-013", serviceTitle: "Fertility Assessment & Counseling",
    hospitalName: "Nanjing Drum Tower Hospital", doctorName: "Dr. Xu Mei",
    preferredDate: "2026-11-15", submittedAt: "2026-10-16",
    status: "under_review", statusNote: "Your request is being reviewed by our medical team.",
  },
  {
    id: "BK-2026-014", serviceTitle: "Pain Management Clinic",
    hospitalName: "First Affiliated Hospital of Xi'an Jiaotong University", doctorName: "Dr. Qian Bing",
    preferredDate: "2026-11-22", submittedAt: "2026-10-14",
    status: "under_review", statusNote: "Your request is being reviewed by our medical team.",
  },
  {
    id: "BK-2026-015", serviceTitle: "Traditional Chinese Medicine Therapy",
    hospitalName: "West China Hospital", doctorName: "Dr. Chen Xiao",
    preferredDate: "2026-11-29", submittedAt: "2026-10-12",
    status: "under_review", statusNote: "Your request is being reviewed by our medical team.",
  },
  {
    id: "BK-2026-016", serviceTitle: "Cardiology Consultation & Treatment",
    hospitalName: "Peking Union Medical College Hospital", doctorName: "Dr. Wang Wei",
    preferredDate: "2026-12-05", submittedAt: "2026-10-09",
    status: "under_review", statusNote: "Your request is being reviewed by our medical team.",
  },
  {
    id: "BK-2026-017", serviceTitle: "Post-Surgery Rehabilitation",
    hospitalName: "Guangzhou First People's Hospital", doctorName: "Dr. Liu Yan",
    preferredDate: "2026-12-12", submittedAt: "2026-10-06",
    status: "under_review", statusNote: "Your request is being reviewed by our medical team.",
  },
  {
    id: "BK-2026-018", serviceTitle: "Teleconsultation (Remote)",
    hospitalName: "Shanghai Ruijin Hospital", doctorName: "Dr. Li Ming",
    preferredDate: "2026-11-30", submittedAt: "2026-10-04",
    status: "under_review", statusNote: "Your request is being reviewed by our medical team.",
  },
  {
    id: "BK-2026-019", serviceTitle: "Orthopedic Surgery",
    hospitalName: "First Affiliated Hospital of Xi'an Jiaotong University", doctorName: "Dr. Qian Bing",
    preferredDate: "2026-11-10", submittedAt: "2026-09-28",
    status: "coordinating", statusNote: "We are coordinating with the hospital for your appointment.",
  },
  {
    id: "BK-2026-020", serviceTitle: "Stroke Recovery Program",
    hospitalName: "Beijing Tiantan Hospital", doctorName: "Dr. Zhang Hua",
    preferredDate: "2026-11-17", submittedAt: "2026-09-25",
    status: "coordinating", statusNote: "We are coordinating with the hospital for your appointment.",
  },
  {
    id: "BK-2026-021", serviceTitle: "Cosmetic & Plastic Surgery",
    hospitalName: "Suzhou Municipal Hospital", doctorName: "Dr. Wu Fang",
    preferredDate: "2026-11-24", submittedAt: "2026-09-22",
    status: "coordinating", statusNote: "We are coordinating with the hospital for your appointment.",
  },
  {
    id: "BK-2026-022", serviceTitle: "Cardiology Consultation & Treatment",
    hospitalName: "Zhejiang University First Affiliated Hospital", doctorName: "Dr. Zhou Qing",
    preferredDate: "2026-12-08", submittedAt: "2026-09-20",
    status: "coordinating", statusNote: "We are coordinating with the hospital for your appointment.",
  },
  {
    id: "BK-2026-023", serviceTitle: "Neurological Consultation",
    hospitalName: "Chongqing Medical University First Affiliated Hospital", doctorName: "Dr. He Jun",
    preferredDate: "2026-12-15", submittedAt: "2026-09-18",
    status: "coordinating", statusNote: "We are coordinating with the hospital for your appointment.",
  },
  {
    id: "BK-2026-024", serviceTitle: "Advanced Oncology Treatment",
    hospitalName: "Nanjing Drum Tower Hospital", doctorName: "Dr. Xu Mei",
    preferredDate: "2026-07-25", submittedAt: "2026-06-10",
    status: "completed", statusNote: "Your treatment has been completed. Follow-up scheduled.",
  },
  {
    id: "BK-2026-025", serviceTitle: "Comprehensive Health Checkup",
    hospitalName: "Shenzhen People's Hospital", doctorName: "Dr. Sun Lei",
    preferredDate: "2026-11-13", submittedAt: "2026-09-12",
    status: "confirmed", statusNote: "Your appointment has been confirmed. Travel details will follow shortly.",
  },
  {
    id: "BK-2026-026", serviceTitle: "Dental Care & Implants",
    hospitalName: "Guangzhou First People's Hospital", doctorName: "Dr. Liu Yan",
    preferredDate: "2026-11-06", submittedAt: "2026-09-08",
    status: "confirmed", statusNote: "Your appointment has been confirmed. Travel details will follow shortly.",
  },
  {
    id: "BK-2026-027", serviceTitle: "Ophthalmology Consultation",
    hospitalName: "Wuhan Union Hospital", doctorName: "Dr. Huang Tao",
    preferredDate: "2026-11-09", submittedAt: "2026-09-05",
    status: "confirmed", statusNote: "Your appointment has been confirmed. Travel details will follow shortly.",
  },
  {
    id: "BK-2026-028", serviceTitle: "Teleconsultation (Remote)",
    hospitalName: "Peking Union Medical College Hospital", doctorName: "Dr. Wang Wei",
    preferredDate: "2026-11-03", submittedAt: "2026-09-02",
    status: "confirmed", statusNote: "Your appointment has been confirmed. Travel details will follow shortly.",
  },
  {
    id: "BK-2026-029", serviceTitle: "Orthopedic Surgery",
    hospitalName: "West China Hospital", doctorName: "Dr. Chen Xiao",
    preferredDate: "2026-08-20", submittedAt: "2026-07-10",
    status: "completed", statusNote: "Your treatment has been completed. Follow-up scheduled.",
  },
  {
    id: "BK-2026-030", serviceTitle: "Cardiology Consultation & Treatment",
    hospitalName: "Shanghai Ruijin Hospital", doctorName: "Dr. Li Ming",
    preferredDate: "2026-09-15", submittedAt: "2026-08-25",
    status: "cancelled", statusNote: "Your booking has been cancelled as requested. No charges applied.",
  },
];

export const bookingStatusConfig: Record<BookingStatus, { label: string; color: string; bgColor: string }> = {
  pending: { label: "Pending", color: "#6B7280", bgColor: "#F3F4F6" },
  under_review: { label: "Under Review", color: "#D97706", bgColor: "#FEF3C7" },
  coordinating: { label: "Coordinating", color: "#2FA79B", bgColor: "#E6F5F3" },
  confirmed: { label: "Confirmed", color: "#059669", bgColor: "#D1FAE5" },
  completed: { label: "Completed", color: "#0F6B68", bgColor: "#E6F5F3" },
  cancelled: { label: "Cancelled", color: "#DC2626", bgColor: "#FEE2E2" },
};

// ============ Travel Assistance ============
export interface TravelService {
  id: string;
  title: string;
  description: string;
  icon: string;
  features: string[];
}

export const travelServices: TravelService[] = [
  {
    id: "translation", title: "Medical Translation",
    description: "Professional medical interpreters for consultations and procedures.",
    icon: "languages",
    features: ["In-person interpreters", "Document translation", "Available in 10+ languages", "Medical terminology experts"],
  },
  {
    id: "escort", title: "Hospital Escort",
    description: "Dedicated companion to guide you through hospital visits.",
    icon: "user-check",
    features: ["Appointment accompaniment", "Navigation assistance", "Communication support", "Post-visit summary"],
  },
  {
    id: "accommodation", title: "Accommodation Arrangement",
    description: "Comfortable lodging near your treatment hospital.",
    icon: "hotel",
    features: ["Hotel booking near hospital", "Extended stay options", "Family accommodation", "Airport pickup available"],
  },
  {
    id: "transport", title: "Airport Transfer & Transport",
    description: "Reliable transportation throughout your medical journey.",
    icon: "car",
    features: ["Airport pickup & drop-off", "Hospital transfers", "City tour options", "24/7 availability"],
  },
  {
    id: "visa-invitation", title: "Visa Invitation Letter",
    description: "Official medical visa invitation letters issued by partner hospitals.",
    icon: "file-text",
    features: ["Hospital-issued letters", "Compliance with embassy requirements", "Express processing available", "Support for multiple entry requests"],
  },
  {
    id: "medical-supplies", title: "Medical Supplies Assistance",
    description: "Help obtaining prescribed medications and medical equipment in China.",
    icon: "package",
    features: ["Prescription procurement", "Delivery to accommodation", "Import/export guidance", "Sterile packaging guarantee"],
  },
  {
    id: "tour-after-recovery", title: "Tour After Recovery",
    description: "Leisure travel packages designed for patients recovering from treatment.",
    icon: "plane",
    features: ["Low-intensity itineraries", "Wheelchair-accessible routes", "Medical backup on call", "Group or private tours"],
  },
  {
    id: "family-companion", title: "Family Companion Program",
    description: "Support services for accompanying family members throughout your stay.",
    icon: "users",
    features: ["Family-friendly accommodation", "Language support for companions", "City orientation activities", "Companion health insurance"],
  },
];

// ============ FAQ ============
export interface FAQItem {
  id: string;
  question: string;
  answer: string;
  category: string;
}

export const faqItems: FAQItem[] = [
  {
    id: "1", category: "General",
    question: "How does ChinaCare+ work?",
    answer: "ChinaCare+ connects international patients with top hospitals in China. Submit your medical needs, our team coordinates with hospitals, and we guide you through every step from consultation to recovery.",
  },
  {
    id: "2", category: "General",
    question: "Is ChinaCare+ a hospital?",
    answer: "No. ChinaCare+ is a medical consultation and service coordination platform. We do not provide medical diagnosis, prescribe medication, or deliver treatment directly. We connect you with accredited hospitals and specialists.",
  },
  {
    id: "3", category: "Booking",
    question: "How long does the booking process take?",
    answer: "Initial review takes 1–3 business days. Hospital coordination typically takes 3–7 business days. Complex cases may require additional time for multidisciplinary review.",
  },
  {
    id: "4", category: "Booking",
    question: "Can I cancel my booking?",
    answer: "You can cancel your request before it reaches 'Confirmed' status at no charge. After confirmation, cancellation policies depend on the hospital's terms. Contact your concierge for assistance.",
  },
  {
    id: "5", category: "Payment",
    question: "How do I pay for medical services?",
    answer: "Medical service fees are paid directly to the hospital. ChinaCare+ service fees are billed separately. We accept international credit cards and bank transfers. Detailed pricing is provided before confirmation.",
  },
  {
    id: "6", category: "Travel",
    question: "Do you help with visa applications?",
    answer: "We provide invitation letters from partner hospitals to support your medical visa application. Visa processing is handled by the Chinese embassy or consulate in your country.",
  },
  {
    id: "7", category: "Privacy",
    question: "How is my medical data protected?",
    answer: "All medical information is encrypted and stored securely. We comply with international data protection standards. Your data is only shared with hospitals you explicitly authorize.",
  },
  {
    id: "8", category: "Privacy",
    question: "What is your privacy policy?",
    answer: "We collect only necessary information to coordinate your care. Data is never sold to third parties. You can request data deletion at any time. Full policy available in our Help Center.",
  },
  {
    id: "9", category: "General",
    question: "Which cities in China do you operate in?",
    answer: "We currently partner with top hospitals in Beijing, Shanghai, Guangzhou, Chengdu, Shenzhen, Hangzhou, Chongqing, Nanjing, Wuhan, Xi'an, and Suzhou. Additional cities are added regularly based on patient demand.",
  },
  {
    id: "10", category: "General",
    question: "Do I need to speak Chinese to use ChinaCare+?",
    answer: "No. All our patient coordinators speak English, and we provide professional medical interpretation services throughout your journey. Hospitals we work with also have English-speaking staff available.",
  },
  {
    id: "11", category: "General",
    question: "What types of conditions do you help treat?",
    answer: "We assist with a wide range of conditions including oncology, cardiology, neurology, orthopedics, cosmetic surgery, dental care, fertility, and general health screenings. Contact us to discuss your specific needs.",
  },
  {
    id: "12", category: "General",
    question: "Can ChinaCare+ provide medical advice?",
    answer: "No, ChinaCare+ does not provide medical diagnosis or advice. All medical opinions and treatments are provided by qualified hospital doctors. We coordinate logistics and help you access expert care.",
  },
  {
    id: "13", category: "Booking",
    question: "What documents do I need to submit with my booking request?",
    answer: "You'll need to provide basic personal information and any relevant medical records such as test results, imaging reports, and a summary of your condition. All documents can be uploaded securely through our platform.",
  },
  {
    id: "14", category: "Booking",
    question: "Can I request a specific doctor or hospital?",
    answer: "Yes. You can indicate your preferred hospital or specialist in your booking request. We will make every effort to accommodate your preference, though availability may vary based on the doctor's schedule.",
  },
  {
    id: "15", category: "Booking",
    question: "Is there a consultation fee for submitting a request?",
    answer: "No, there is no fee to submit a request or receive an initial assessment. Our service fees only apply when you confirm a booking with us.",
  },
  {
    id: "16", category: "Booking",
    question: "How long in advance should I book?",
    answer: "For routine checkups and consultations, we recommend booking 2–4 weeks in advance. For surgical procedures or complex treatments, please allow 4–8 weeks for proper coordination and pre-operative planning.",
  },
  {
    id: "17", category: "Payment",
    question: "Do you accept insurance?",
    answer: "Some of our partner hospitals accept international health insurance. We recommend checking with your insurance provider first. Our team can assist with insurance claim documentation, but direct billing depends on the specific hospital and your insurer.",
  },
  {
    id: "18", category: "Payment",
    question: "Can I pay in my home currency?",
    answer: "ChinaCare+ service fees can be invoiced and paid in major international currencies including USD, EUR, GBP, and AUD. Hospital fees are typically settled in CNY but can sometimes be paid in USD at the hospital.",
  },
  {
    id: "19", category: "Payment",
    question: "Is there a payment plan available?",
    answer: "For treatments exceeding $10,000, we may be able to arrange a staged payment plan. Typically, a deposit is required to confirm your appointment, with the balance settled upon arrival at the hospital.",
  },
  {
    id: "20", category: "Payment",
    question: "What happens if I don't need treatment after arriving?",
    answer: "If a doctor determines no treatment is needed, you will only be charged for the consultation and any tests performed. Our coordination fee may be partially refunded depending on how much work has been completed.",
  },
  {
    id: "21", category: "Travel",
    question: "How long should I stay in China for treatment?",
    answer: "Recovery times vary by procedure. Health checkups typically require 1–3 days, consultations 1–2 days, and surgical procedures 1–4 weeks including recovery. Your doctor will provide a specific timeline during your consultation.",
  },
  {
    id: "22", category: "Travel",
    question: "Do you arrange flights to China?",
    answer: "We do not book flights directly, but we can provide guidance on airlines, entry requirements, and best times to travel. Our team will help you understand the specific visa and health documentation needed.",
  },
  {
    id: "23", category: "Travel",
    question: "Is China safe for international patients?",
    answer: "Yes, China is generally a safe country for travelers. Major hospitals and tourist areas are well-equipped for international visitors. Our on-the-ground team provides 24/7 support throughout your stay for added peace of mind.",
  },
  {
    id: "24", category: "Travel",
    question: "Can my family accompany me during treatment?",
    answer: "Absolutely. We encourage family support and offer family companion services including accommodation arrangement, translation assistance, and city orientation activities for your loved ones.",
  },
  {
    id: "25", category: "Privacy",
    question: "Who will have access to my medical records?",
    answer: "Only the hospitals and doctors you explicitly authorize will receive your medical information. ChinaCare+ staff involved in coordinating your care also access records on a need-to-know basis, under strict confidentiality agreements.",
  },
  {
    id: "26", category: "Privacy",
    question: "How long do you keep my data?",
    answer: "We retain your data for a minimum of 7 years after the completion of your last service to comply with medical record-keeping requirements. After that period, data is securely anonymized or deleted as you prefer.",
  },
  {
    id: "27", category: "Privacy",
    question: "Can I export or delete my data?",
    answer: "Yes. You can request a complete export of all your data at any time. You may also request full deletion of your account and data, subject to any legal retention requirements. Submit requests through your account settings or contact support.",
  },
  {
    id: "28", category: "Other",
    question: "Do you offer teleconsultation services?",
    answer: "Yes, we provide remote teleconsultation with leading specialists in China. This is ideal for getting a second opinion, understanding your diagnosis, or planning a trip before you travel. Teleconsultations are conducted via secure video platform.",
  },
  {
    id: "29", category: "Other",
    question: "What should I pack for my medical trip to China?",
    answer: "Pack your prescriptions, medical records in English and original language, comfortable clothing, and any assistive devices you use. Our team will provide a detailed packing list 1–2 weeks before your departure based on your specific treatment plan.",
  },
  {
    id: "30", category: "Other",
    question: "How do I leave a review after my treatment?",
    answer: "After completing your treatment, you will receive an automated email with a link to submit a review. Your feedback helps other patients make informed decisions and helps us improve our services. We also welcome direct feedback to our support team.",
  },
];

// ============ How It Works ============
export interface HowItWorksStep {
  step: number;
  title: string;
  icon: string;
}

export const howItWorksSteps: HowItWorksStep[] = [
  { step: 1, title: "Submit Your Request", icon: "clipboard-list" },
  { step: 2, title: "Medical Assessment", icon: "user-check" },
  { step: 3, title: "Come to China", icon: "plane" },
  { step: 4, title: "Treatment & Follow-up", icon: "heart-pulse" },
];

export const serviceCategories = [
  { id: "health-checkup", title: "Health Checkup", icon: "stethoscope", color: "#0F6B68", bgColor: "#E7F6F0" },
  { id: "medical-treatment", title: "Medical Treatment", icon: "hospital", color: "#4B7BF5", bgColor: "#EAF1FF" },
  { id: "surgery", title: "Surgery Services", icon: "scalpel", color: "#E8674F", bgColor: "#FDECE7" },
  { id: "recovery", title: "Recovery & Rehabilitation", icon: "heart-pulse", color: "#8B5CF6", bgColor: "#F1EAFE" },
];
